export default "__VITE_ASSET__QrOZIlqP__"